import CityPageTemplate from "../city-template/CityPageTemplate";
import { glendaleConfig } from "./data";

export default function GlendalePage() {
  return <CityPageTemplate config={glendaleConfig} />;
}